import { render } from "./DJvirtualCommerce.vue?vue&type=template&id=35c6f001&scoped=true"
import script from "./DJvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./DJvirtualCommerce.vue?vue&type=script&lang=js"

import "./DJvirtualCommerce.vue?vue&type=style&index=0&id=35c6f001&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35c6f001"

export default script